// @flow

import type { PropsSchema, BasicProps } from '../../type'
import * as React from 'react'
import computeData from '../hoc/computeData'

type Props = BasicProps & {
  style: { [string]: string },
  config: any,
  customProps?: any
};

@computeData({ includeData: true })
export default class Highstock extends React.PureComponent<
  Props,
  { ReactHighstock?: any }
> {
  state = {};

  static schema: PropsSchema = [
    {
      title: '图表配置',
      key: 'config',
      type: 'code'
    },
    'separator',
    {
      type: 'style'
    }
  ];

  constructor (props: Props) {
    super(props)
    import('react-highcharts/ReactHighstock').then(ReactHighstock => {
      this.setState({ ReactHighstock })
    })
  }

  render () {
    const { id, style, visible, jsEnv } = this.props
    let { config } = this.props
    if (!visible) {
      return null
    }
    if (!config) {
      return null
    }
    config = jsEnv.runCode(config)
    const { ReactHighstock } = this.state
    if (ReactHighstock && config) {
      return <ReactHighstock id={id} style={style} config={config} />
    }
    return null
  }
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/basic/Highstock.js